<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
        <v-flex sm3 md3>
          <buyer-list @tabSelected="tabSelected"/>
        </v-flex>
        <v-flex sm9 md9>
          <buyer :isBuyer="isBuyer"/>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Buyer from './Buyer/'
import BuyerList from './BuyerList/'

import { createNamespacedHelpers } from 'vuex'
const mapBuyerActions = createNamespacedHelpers('Buyer')['mapActions']

export default {
  data () {
    return {
      isBuyer: true
    }
  },
  components: {
    Buyer,
    BuyerList
  },
  methods: {
    ...mapBuyerActions(['SET_SELECTED_CUSTOMER']),
    tabSelected (index) {
      this.isBuyer = index ? false : true
    }
  },
  created () {
    const { buyerId } = this.$route.params;
    this.SET_SELECTED_CUSTOMER(buyerId);
    const { isBuyer } = this.$route.params;
    if(isBuyer != undefined || isBuyer != null) {
      this.isBuyer = isBuyer == 'true' ? true : false
    }
  },
  beforeRouteUpdate (to, from, next) {
    const { buyerId } = to.params
    this.SET_SELECTED_CUSTOMER(buyerId)
    next()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Buyers/index.vue